import React from 'react';
import moment from 'moment';
import {
  GridCell,
  GridRow,
} from '../../../../../../../common/components/Grid/Grid';
import { MiddleTrim } from '../../../../../../../common/components/MiddleTrim/MiddleTrim';
import { QueuedContactType } from '@mm/state/model/CampaignsModel';

type Props = {
  contact: QueuedContactType;
};

export const ContactRow = ({ contact }: Props) => {
  const GMTOffset =
    Number(contact.offset) > 0
      ? `GMT+${contact.offset}`
      : `GMT${contact.offset}`;
  const scheduledAt = moment(contact.scheduledAt)
    .add(contact.offset, 'hours')
    .format('MM/DD/YYYY, h:mm:ss a');
  return (
    <GridRow className="campaign-queue-modal__grid-body">
      <GridCell>
        <MiddleTrim maxLength={25}>{contact.name}</MiddleTrim>
      </GridCell>
      <GridCell>
        <span>{`${scheduledAt} - ${GMTOffset}`}</span>
      </GridCell>
    </GridRow>
  );
};
